import { cx } from 'src/utils/cx'

export function CardCornerOverlay({
  children,
  corner = 'bottom-left',
  className,
}: {
  children?: React.ReactNode
  corner: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  className?: string
}) {
  return (
    <div
      className={cx(
        'absolute py-2 px-3 md:px-4 text-sm md:text-base z-10 bg-gray-900/60 shadow-lg',
        {
          'rounded-tr-lg bottom-0 left-0': corner === 'bottom-left',
          'rounded-tl-lg bottom-0 right-0': corner === 'bottom-right',
          'rounded-br-lg top-0 left-0': corner === 'top-left',
          'rounded-bl-lg top-0 right-0': corner === 'top-right',
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
